export const SERIES = {
  HIGHLIGHT: 'HIGHLIGHT',
  PRACTICE: 'PRACTICE',
};

export const SITUATION = {
  ADVANTAGED: 'advantaged',
  DISADVANTAGED: 'disadvantaged',
  DOMINANT: 'dominant',
  EVEN: 'even',
  LOSING: 'losing',
  OPEN: 'open',
  PLAYER_LOSE: 'playerLose',
  PLAYER_WIN: 'playerWin',
  RANDOM: 'random',
};

export default {SERIES, SITUATION};
